(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-story"] && !Shopify.designMode) return;
  try {
    if (!window.__productStoryBound) {
    window.__productStoryBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-product-story-more]');
      if (!button) return;

      var text = button.closest('[data-product-story-text]');
      if (!text) return;

      var expanded = text.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
    });

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = window.Shopify && Shopify.designMode;

    function isVisibleStory(tagline) {
      var story = tagline.closest('.product-story');
      if (!story) return false;
      var desktop = window.matchMedia('(min-width: 768px)').matches;
      if (desktop) return story.classList.contains('product-story--media');
      return story.classList.contains('product-story--info');
    }

    function finishTagline(tagline, textEl, fullText, pen) {
      textEl.textContent = fullText;
      tagline.classList.add('is-written');
      tagline.classList.remove('is-writing');
      if (pen) {
        pen.classList.remove('is-writing');
        pen.classList.add('is-resting');
      }
      scheduleTaglineRepeat(tagline);
    }

    function resetTagline(tagline) {
      tagline.classList.remove('is-written', 'is-writing');
      var pen = tagline.querySelector('.product-story__pen');
      if (pen) {
        pen.classList.remove('is-writing', 'is-resting');
      }
    }

    function scheduleTaglineRepeat(tagline) {
      var seconds = parseInt(tagline.getAttribute('data-repeat'), 10) || 0;
      if (seconds < 1) return;

      clearTimeout(tagline._penRepeatTimer);
      tagline._penRepeatTimer = setTimeout(function () {
        if (document.hidden) {
          var onVisible = function () {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVisible);
            resetTagline(tagline);
            writeTagline(tagline);
          };
          document.addEventListener('visibilitychange', onVisible);
          return;
        }

        resetTagline(tagline);
        writeTagline(tagline);
      }, seconds * 1000);
    }

    function writeTagline(tagline) {
      if (tagline.classList.contains('is-writing')) return;

      var textEl = tagline.querySelector('.product-story__tagline-text');
      var pen = tagline.querySelector('.product-story__pen');
      var fullText = tagline.getAttribute('data-text') || (textEl && textEl.textContent) || '';
      if (!textEl || !fullText) return;

      tagline.classList.add('is-writing');
      textEl.textContent = '';
      if (pen) pen.classList.add('is-writing');

      var index = 0;
      var step = function () {
        index += 1;
        textEl.textContent = fullText.slice(0, index);
        if (index < fullText.length) {
          var nextChar = fullText.charAt(index);
          var delay = nextChar === ' ' ? 40 : 68;
          setTimeout(step, delay);
        } else {
          finishTagline(tagline, textEl, fullText, pen);
        }
      };

      setTimeout(step, 180);
    }

    function initTaglineWriting() {
      var taglines = document.querySelectorAll('[data-product-story-tagline]');
      if (!taglines.length) return;

      if (reduceMotion || inEditor) {
        taglines.forEach(function (tagline) {
          tagline.classList.add('is-written');
          var pen = tagline.querySelector('.product-story__pen');
          if (pen) pen.classList.add('is-resting');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            writeTagline(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.6 }
      );

      taglines.forEach(function (tagline) {
        if (!isVisibleStory(tagline)) {
          tagline.classList.add('is-written');
          var pen = tagline.querySelector('.product-story__pen');
          if (pen) pen.classList.add('is-resting');
          return;
        }

        var textEl = tagline.querySelector('.product-story__tagline-text');
        if (textEl) textEl.textContent = '';
        observer.observe(tagline);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTaglineWriting);
    } else {
      initTaglineWriting();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
